exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div.swatches-picker > div > div {\n  box-shadow: none !important; }\n\ndiv.swatches-picker > div > div > div > div {\n  padding-left: 0px !important; }\n", ""]);

